import React from 'react';
import type { FC } from 'react';

interface LogoProps {
  dark?: boolean;
}

const Logo: FC<LogoProps> = ({ dark }) => (
  <img
    alt="Logo"
    src="/static/tracktaco-logo.png"// {/* dark ? '/static/logo.png' : '/static/oag-logo-white.png' */}
    width="200"
  />
);

export default Logo;
